export const FETCH_CASINO_SUBMENU_GAMES_START =
	'@komigen/mobile-frontend/submenu-games/FETCH_CASINO_SUBMENU_GAMES_START';

export const FETCH_CASINO_SUBMENU_GAMES_SUCCESS =
	'@komigen/mobile-frontend/submenu-games/FETCH_CASINO_SUBMENU_GAMES_SUCCESS';

export const FETCH_CASINO_SUBMENU_GAMES_FAILURE =
	'@komigen/mobile-frontend/submenu-games/FETCH_CASINO_SUBMENU_GAMES_FAILURE';
